export class PaymentGateway {
  constructor(config) {
    this.api_url = config.api_url;
  }

  redirect_to_payment_panel(transaction_token) {
    window.open(`${this.api_url}/trnRequest/${transaction_token}`, "_self");
  }
}
